export const toKebabCase = (str) => `${str.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
export const toCssVarNameForamt = (str) => `--${toKebabCase(str)}`;
//# sourceMappingURL=index.js.map